<template>

  <div
    class="btn-group">
    <button
      class="btn btn-secondary dropdown-toggle"
      type="button"
      id="dropdownMenuButton2"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false">
      {{ $t('Templates') }}
    </button>
    <div
      class="dropdown-menu"
      aria-labelledby="dropdownMenuButton2"
      style="overflow: auto; max-height: 200px">
      <a
        class="dropdown-item"
        href="javascript:void(0)"
        v-for="(item, index) in templatemails"
        :key="index"
        @click="setTemplate(item)">
        {{ item.name }}
        </a>
      <div
        v-if="!templatemails.length"
        class="text-muted p-2">{{ $t('No templates found') }}</div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'TemplatemailSelect',
  props: [
  ],
  data () {
    return {
      templatemails: []
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.$store
      .dispatch('getTemplatemails', {sort: 'name', limit: 100})
      .then((result) => {
        this.templatemails = result.docs
      })
    },
    /*
    setTemplate
    */
    setTemplate (template) {
      const value = this.$clone(template)
      this.$emit('setTemplate', value)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Parts/TemplatemailSelect.vue